import React from "react";
import Downshift from "downshift";
import PropTypes from "prop-types";

import "./Autocomplete.scss";
import { GREEN_LIGHT } from "../../../styles/shared/colors";

const Autocomplete = ({
  input,
  items,
  defaultSelectedItem,
  defaultInputValue,
  inputClassName,
  placeholder
}) => {
  return (
    <Downshift
      {...input}
      itemToString={item => (item ? item.value : "")}
      onChange={({ value }) => input && input.onChange(value)}
      defaultSelectedItem={defaultSelectedItem}
      defaultInputValue={defaultInputValue}
    >
      {({
        getItemProps,
        getInputProps,
        getMenuProps,
        inputValue,
        isOpen,
        highlightedIndex,
        selectedItem
      }) => (
        <div className="autocomplete">
          <input
            {...getInputProps({ placeholder })}
            className={`autocomplete__button ${inputClassName}`}
          />
          <ul
            className="autocomplete__menu"
            {...getMenuProps()}
            style={{ height: isOpen ? "auto" : "0px" }}
          >
            {isOpen
              ? items
                  .filter(
                    item =>
                      !inputValue ||
                      item.value
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                  )
                  .map((item, index) => (
                    <li
                      key={item.value}
                      {...getItemProps({
                        key: item.value,
                        className: "autocomplete__menu__item",
                        index,
                        item,
                        style: {
                          backgroundColor:
                            highlightedIndex === index ? GREEN_LIGHT : null,
                          fontWeight: selectedItem === item ? "bold" : "normal"
                        }
                      })}
                    >
                      {item.value}
                    </li>
                  ))
              : null}
          </ul>
        </div>
      )}
    </Downshift>
  );
};

Autocomplete.propTypes = {
  defaultInputValue: PropTypes.string,
  defaultSelectedItem: PropTypes.string,
  input: PropTypes.string,
  inputClassName: PropTypes.string,
  items: PropTypes.array,
  placeholder: PropTypes.string
};

Autocomplete.defaultProps = {
  defaultInputValue: "",
  defaultSelectedItem: "",
  input: "",
  inputClassName: "",
  items: [],
  placeholder: ""
};

export default Autocomplete;
